import React from "react";
import { BoxSpg, GridSpg, isArrayNotEmpty, iTxt, SecurityGuard, WithChildren } from "@duosoftbg/nacid-components";
import CategoryIcon from "./CategoryIcon";
import CategoryContent from "./CategoryContent";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import {
  clearSelectedCategory,
  setSelectedCategory,
} from "../../../../store/redux/slice/ComponentsControl/homePageControl";
import { getI18n } from "react-i18next";

type CategoryTileProps = WithChildren<{
  svgIconComponent: any;
  category;
}>;

const CategoryTile = ({ children, svgIconComponent, category }: CategoryTileProps) => {
  const accessRoles = category.accessRoles;

  return (
    <>
      {category.active && (
        <SecurityGuard checkForRoles={accessRoles} doCheck={isArrayNotEmpty(accessRoles)} roleOperator={"or"}>
          <CategoryTitleContent
            children={children}
            category={category}
            svgIconComponent={svgIconComponent}
          ></CategoryTitleContent>
        </SecurityGuard>
      )}
    </>
  );
};

export default CategoryTile;

const CategoryTitleContent = ({ children, svgIconComponent, category }) => {
  const dispatch = useAppDispatch();

  const selectedCategory = useAppSelector((state) => {
    return state.ComponentsControl.homePageControl.selectedCategory;
  });

  const title = iTxt(getI18n().language, category?.name, category?.nameEn);
  const show = title === selectedCategory;

  const toggleShow = () => {
    if (selectedCategory === title) {
      dispatch(clearSelectedCategory({}));
    } else {
      dispatch(setSelectedCategory({ id: title }));
    }
  };
  return (
    <GridSpg className={"categoryTile"} style={{ paddingLeft: 0 }} item xs={12} sm={12} md={3} lg={3}>
      <BoxSpg>
        <CategoryIcon
          showServiceContainer={show}
          onClick={toggleShow}
          svgIconComponent={svgIconComponent}
          title={title}
        />
        {show && <CategoryContent>{children}</CategoryContent>}
      </BoxSpg>
    </GridSpg>
  );
};
